const colors = {
  defaultFront: '#0D0D0D',
  border: '#E6E9ED',
  bg: '#F8F9FA',
  brandPrimary: {
    100: '#FED7E2',
    200: '#FEDCDC',
    300: '#FCABAB',
    400: '#FB7979',
    500: '#F94848',
    600: '#F71717',
    700: '#D40707',
    800: '#A30505',
    900: '#710404',
  },
  brandSecondary: {
    100: '#AEBACE',
    400: '#556B8E',
    500: '#42536E',
    600: '#2F3B4E',
    700: '#1C232E',
    800: '#090B0E',
    900: '#090B0E',
  },
  brandRed: {
    100: '#FBDDDD',
    500: '#E52727',
  },
  brandGray: {
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#2D3748',
  },
  blackAlpha: {
    50: 'rgba(000,000,000,.04)',
    100: 'rgba(000,000,000,.06)',
    200: 'rgba(000,000,000,.08)',
    300: 'rgba(000,000,000,.16)',
    400: 'rgba(000,000,000,.24)',
    500: 'rgba(000,000,000,.36)',
    600: 'rgba(000,000,000,.48)',
    700: 'rgba(000,000,000,.64)',
    800: 'rgba(000,000,000,.80)',
    900: 'rgba(000,000,000,.92)',
  },
}

export default colors
